@if (show2d()) {
  <div id="view2d" #view2d></div>
}
@if (show3d()) {
  <div id="view3d" #view3d></div>
}
<jmkw-basemap-selector viewType="2D"></jmkw-basemap-selector>
<jmkw-basemap-selector viewType="3D"></jmkw-basemap-selector>
